// extracted by mini-css-extract-plugin
export default {"PhaseNav":"PhaseNav_PhaseNav__E+QqZ","PhaseNav__tabs":"PhaseNav_PhaseNav__tabs__dykeT"};